(function () {
  'use strict';

  /* --- Common - Start --- */

  const classHide = 'cil-hide',
    classOpen = 'cil-open';

  //

  const dataAttrAction = 'data-cil-action',
    dataListenerType = 'data-cil-listener-type';

  const dataValActionPlay = 'play',
    dataValActionPause = 'pause',
    dataValListenerTypeClick = 'click',
    dataValListenerTypeEvent = 'event';

  //

  const eventToggle = 'cil-toggle',
    eventVideoControl = 'cil-video-control';

  const selectorMainAtc = 'form .product-form__checkout button';

  /* --- Common - End --- */

  //
  //
  //
  //
  //

  /* --- Button Icon - 2 States - Start */

  class CilButtonIcon2s extends HTMLElement {
    constructor() {
      super();

      this.toggleState = this.toggleState.bind(this);
      this.updateState = this.updateState.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('button');

      if (this.button) {
        this.icon1 = this.button.querySelector('svg.cil-icon:first-of-type');
        this.icon2 = this.button.querySelector('svg.cil-icon:last-of-type');

        if (this.icon1) {
          this.action1 = this.icon1.getAttribute(dataAttrAction);
        }
        if (this.icon2) {
          this.action2 = this.icon2.getAttribute(dataAttrAction);
        }

        this.addEventListener('click', this.toggleState);
        this.button.addEventListener(eventVideoControl, this.updateState);
      }
    }

    disconnectedCallback() {
      if (this.button) {
        this.removeEventListener('click', this.toggleState);
        this.button.removeEventListener(eventVideoControl, this.updateState);
      }
    }

    toggleState() {
      if (!this.icon1 || !this.icon2) {
        return;
      }

      let action;
      if (this.icon1.classList.contains(classHide)) {
        action = this.action2;

        this.icon2.classList.add(classHide);
        this.icon1.classList.remove(classHide);
      } else {
        action = this.action1;

        this.icon1.classList.add(classHide);
        this.icon2.classList.remove(classHide);
      }

      // Dispatch a custom event with the action.
      this.button.dispatchEvent(new CustomEvent(eventToggle, {
        detail: { action: action },
        bubbles: false // Prevents the event from bubbling up the DOM tree.
      }));
    }

    updateState(event) {
      const action = event.detail.action;

      if (!this.icon1 || !this.icon2) {
        return;
      }

      if (this.action1 === action) {
        if (!this.icon1.classList.contains(classHide)) {
          this.icon1.classList.add(classHide);
          this.icon2.classList.remove(classHide);
        }
        return;
      }

      if (!this.icon2.classList.contains(classHide)) {
        this.icon2.classList.add(classHide);
        this.icon1.classList.remove(classHide);
      }
    }
  }

  customElements.define('cil-button-icon-2s', CilButtonIcon2s);

  /* --- Button Icon - 2 States - End */

  //
  //

  /* --- Video Player - Start --- */

  class CilVideo extends HTMLElement {
    constructor() {
      super();

      this.hidePreview = this.hidePreview.bind(this);
      this.playVideo = this.playVideo.bind(this);
      this.pauseVideo = this.pauseVideo.bind(this);
      this.sendPostMessage = this.sendPostMessage.bind(this);
      this.handleVideoControlPlay = this.handleVideoControlPlay.bind(this);
      this.handleVideoControlPause = this.handleVideoControlPause.bind(this);

      this.videoType = this.getAttribute('data-cil-type');
    }

    connectedCallback() {
      this.videoPreview = this.querySelector('.cil-video-preview');
      this.videoContainer = this.querySelector('.cil-video-container');

      if (this.videoPreview) {
        this.videoPreview.addEventListener('click', this.playVideo);
      }

      if (this.videoContainer) {
        switch (this.videoType) {
          case 'youtube':
            break;
          case 'vimeo':
            break;
          case `video`:
            const videoElement = this.videoContainer.querySelector('video');
            if (videoElement) {
              videoElement.addEventListener('play', this.handleVideoControlPlay);

              videoElement.addEventListener('pause', this.handleVideoControlPause);
            }
            break;
        }
      }
    }

    disconnectedCallback() {
      if (this.videoPreview) {
        this.videoPreview.removeEventListener('click', this.playVideo);
      }

      if (this.videoContainer) {
        switch (this.videoType) {
          case 'youtube':
            break;
          case 'vimeo':
            break;
          case `video`:
            const videoElement = this.videoContainer.querySelector('video');
            if (videoElement) {
              videoElement.removeEventListener('play', this.handleVideoControlPlay);

              videoElement.removeEventListener('pause', this.handleVideoControlPause);
            }
            break;
        }
      }
    }

    //

    hidePreview() {
      if (!this.videoPreview || !this.videoContainer) {
        return false;
      }

      if (this.videoContainer.classList.contains(classHide)) {
        this.videoContainer.classList.remove(classHide);
        this.videoPreview.classList.add(classHide);
      }

      return true;
    }

    playVideo() {
      let proceed = this.hidePreview();
      if (!proceed) {
        return;
      }

      switch (this.videoType) {
        case 'youtube':
          this.sendPostMessage('.cil-js-youtube', {
            event: 'command',
            func: 'playVideo',
            args: '',
          });
          break;
        case 'vimeo':
          this.sendPostMessage('.cil-js-vimeo', {
            method: 'play',
          });
          break;
        case `video`:
          const videoElement = this.videoContainer.querySelector('video');
          if (videoElement) {
            videoElement.play();
          }
          break;
      }
    }

    pauseVideo() {
      let proceed = this.hidePreview();
      if (!proceed) {
        return;
      }

      switch (this.videoType) {
        case 'youtube':
          this.sendPostMessage('.cil-js-youtube', {
            event: 'command',
            func: 'pauseVideo',
            args: '',
          });
          break;
        case 'vimeo':
          this.sendPostMessage('.cil-js-vimeo', {
            method: 'pause',
          });
          break;
        case `video`:
          const videoElement = this.videoContainer.querySelector('video');
          if (videoElement) {
            videoElement.pause();
          }
          break;
      }
    }

    // Helper function that sends a postMessage to an iframe if it's found.
    sendPostMessage(selector, messageObj) {
      const iframe = this.videoContainer.querySelector(selector);
      if (!iframe || !iframe.contentWindow) {
        return;
      }

      iframe.contentWindow.postMessage(JSON.stringify(messageObj), '*');
    }

    //

    handleVideoControlPlay() {
      // Dispatch a custom event with the action.
      this.dispatchEvent(new CustomEvent(eventVideoControl, {
        detail: { action: dataValActionPlay },
        bubbles: false
      }));
    }

    handleVideoControlPause() {
      // Dispatch a custom event with the action.
      this.dispatchEvent(new CustomEvent(eventVideoControl, {
        detail: { action: dataValActionPause },
        bubbles: false
      }));
    }
  }

  customElements.define('cil-video', CilVideo);

  /* --- Video Player - End --- */

  //
  //
  //
  //

  /* --- Course Overview - Start --- */

  class CilCourseOverview extends HTMLElement {
    constructor() {
      super();

      this.handleVideoAction = this.handleVideoAction.bind(this);
      this.playVideo = this.playVideo.bind(this);
      this.pauseVideo = this.pauseVideo.bind(this);
      this.handleVideoControlAction = this.handleVideoControlAction.bind(this);
    }

    connectedCallback() {
      if (!this.querySelector('div')) {
        // Empty course overview. Hide the parent section.
        const parentSection = this.closest('section');
        if (parentSection) {
          parentSection.classList.add('cil-hide');
        }
        return;
      }

      //

      this.videoButtonElement = this.querySelector('.cil-video-button');
      this.videoElement = this.querySelector('cil-video');

      if (this.videoButtonElement) {
        this.videoButtonListenerType = this.videoButtonElement.getAttribute(dataListenerType);
        switch (this.videoButtonListenerType) {
          case dataValListenerTypeClick:
            this.videoButtonElement.addEventListener('click', this.playVideo);
            break;
          case dataValListenerTypeEvent:
            this.videoButtonElement.addEventListener(eventToggle, this.handleVideoAction);
            break;
          default:
            break;
        }
      }

      if (this.videoElement) {
        this.videoElement.addEventListener(eventVideoControl, this.handleVideoControlAction);
      }
    }

    disconnectedCallback() {
      if (this.videoButtonElement) {
        switch (this.videoButtonListenerType) {
          case dataValListenerTypeClick:
            this.videoButtonElement.removeEventListener('click', this.playVideo);
            break;
          case dataValListenerTypeEvent:
            this.videoButtonElement.removeEventListener(eventToggle, this.handleVideoAction);
            break;
          default:
            break;
        }
      }

      if (this.videoElement) {
        this.videoElement.removeEventListener(eventVideoControl, this.handleVideoControlAction);
      }
    }

    //

    handleVideoAction(event) {
      const action = event.detail.action;
      if (dataValActionPlay === action.toLocaleLowerCase()) {
        this.playVideo();
        return;
      }

      this.pauseVideo();
    }

    playVideo() {
      if (this.videoElement) {
        this.videoElement.playVideo();
      }
    }

    pauseVideo() {
      if (this.videoElement) {
        this.videoElement.pauseVideo();
      }
    }

    //

    handleVideoControlAction(event) {
      // Dispatch a custom event with the action.
      this.videoButtonElement.dispatchEvent(new CustomEvent(eventVideoControl, {
        detail: { action: event.detail.action },
        bubbles: false
      }));
    }

  }

  customElements.define('cil-course-overview', CilCourseOverview);

  /* --- Course Overview - End --- */

  //
  //

  /* --- Sitcky Add to Cart Bar - Start --- */

  class CilStickyATCBar extends HTMLElement {
    constructor() {
      super();

      this.handleAtcClick = this.handleAtcClick.bind(this);
    }

    connectedCallback() {
      this.mainAtc = document.querySelector(selectorMainAtc); // Assuming the main ATC button is not removed and re-added.
      this.stickyAtcButton = this.querySelector('.cil-atc-button-container button');

      this.stickyHeaderOffset = document.querySelector('.shopify-section-header').offsetHeight;

      if (this.stickyAtcButton) {
        this.stickyAtcButton.addEventListener('click', this.handleAtcClick);

        this._setupVisibilityObservers();
      }
    }

    disconnectedCallback() {
      if (this.stickyAtcButton) {
        this.stickyAtcButton.removeEventListener('click', this.handleAtcClick);
      }
    }

    handleAtcClick() {
      if (!this.mainAtc) {
        return;
      }

      this.stickyAtcButton.disabled = true;

      this.mainAtc.click();

      setTimeout(() => {
        this.stickyAtcButton.disabled = false;
      }, 5000);
    }

    _setupVisibilityObservers() {
      if (!this.mainAtc || !this.stickyHeaderOffset) {
        return;

      }

      const classBarOpen = 'cil-sticky-atc-bar-open';

      let flagMainAtcPassed = false;

      this.intersectionObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.target === this.mainAtc) {
            const boundingRect = this.mainAtc.getBoundingClientRect();
            flagMainAtcPassed = entry.intersectionRatio === 0 && boundingRect.top + boundingRect.height <= this.stickyHeaderOffset;
            return;
          }
        });

        let showBar = flagMainAtcPassed;
        if (showBar) {
          document.body.classList.add(classBarOpen);
        } else {
          document.body.classList.remove(classBarOpen);
        }
      },
        { rootMargin: `-${this.stickyHeaderOffset}px 0px 0px 0px` });

      this.intersectionObserver.observe(this.mainAtc);
    }
  }

  customElements.define('cil-sticky-atc-bar', CilStickyATCBar);

  /* --- Sitcky Add to Cart Bar - End --- */

  //
  //
  //
  //
  //

  /* --- Accordion - Start --- */

  function initAccordions() {
    const accordionContainers = document.querySelectorAll('.cil-accordion-container');
    accordionContainers.forEach(accordionContainer => {
      accordionContainer.querySelectorAll('.cil-accordion').forEach(accordionElement => {
        const accordionHeader = accordionElement.querySelector('.cil-accordion-header');
        const accordionContent = accordionElement.querySelector('.cil-accordion-content');

        if (!accordionHeader || !accordionContent) {
          return;
        }

        accordionHeader.addEventListener('click', () => {
          if (accordionElement.classList.contains(classOpen)) {
            // Close this accordion.
            accordionElement.classList.remove(classOpen);
            return;
          }

          // Close open accordions.
          accordionContainer.querySelectorAll('.cil-accordion.' + classOpen).forEach(accordionElement => {
            accordionElement.classList.remove(classOpen);
          });
          // Open this accordion.
          accordionElement.classList.add(classOpen);
        });
      });
    });
  }

  /* --- Accordion - End --- */

  //
  //
  //
  //

  document.addEventListener('DOMContentLoaded', () => {
    initAccordions();
  });

}());